import { api } from './base';

import { rewardsService } from 'v2/api/rewardsService';
import { MutationArg } from 'v2/types';
import { SWRKeyValue } from 'v2/types/swr';
import {
  ITelegramBotSettingsForm,
  TelegramBotDropModel,
  TelegramBotSettingsModel,
  TelegramBotDropForm,
} from 'v2/types/TelegramBotSettingsModel';

export const telegramBotService = {
  getTelegramBotSettings(): Promise<TelegramBotSettingsModel> {
    return api.get('v1/admin/telegram-bot/settings').json();
  },

  updateTelegramBotSettings(
    _key: string,
    { arg }: MutationArg<ITelegramBotSettingsForm>
  ): Promise<TelegramBotSettingsModel> {
    return api.put('v1/admin/telegram-bot/settings', { json: arg }).json();
  },

  getTelegramBotDrops(): Promise<TelegramBotDropModel[]> {
    return api.get('v1/admin/telegram-bot/drop').json();
  },

  createTelegramBotDrop(_key: string, { arg }: MutationArg<TelegramBotDropForm>): Promise<TelegramBotDropModel> {
    return rewardsService
      .createRewards('createRewards', { arg: arg.rewards })
      .then((rewardIds) =>
        api.post('v1/admin/telegram-bot/drop', { json: { chanceToWin: Number(arg.chanceToWin), rewardIds } }).json()
      );
  },

  updateTelegramBotDrop(
    [_key, dropId]: SWRKeyValue,
    { arg }: MutationArg<TelegramBotDropForm>
  ): Promise<TelegramBotDropModel> {
    return rewardsService
      .createRewards('createRewards', { arg: arg.rewards })
      .then((rewardIds) =>
        api
          .put(`v1/admin/telegram-bot/drop/${dropId}`, { json: { chanceToWin: Number(arg.chanceToWin), rewardIds } })
          .json()
      );
  },

  deleteTelegramBotDrop([_key, dropId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/telegram-bot/drop/${dropId}`).json();
  },

  resetTelegramBotRoll(): Promise<void> {
    return api.patch('v1/admin/user/reset/telegram/roll-date').json();
  },
};
